import { TimerInstance, useLogger } from "@amzn/xb-hooks";

export const useTimerHookProvider = (metricName: string): TimerInstance => {
  const { time } = useLogger();
  return {
    start: () => {
      const startTime = new Date();
      return () => time(metricName, new Date().getTime() - startTime.getTime());
    },
  };
};
